import { Role } from './enums';

export enum AuthTypes {
  LOG_IN = 'log_in',
  LOG_OUT = 'log_out',
  VERIFY_TOKEN = 'verify_token',
  TOGGLE_LOADING = 'toggle_loading',
  UPDATE_USER_DATA = 'update_user_data',
}

export enum AuthProvider {
  Google = 'google',
  Email = 'email',
  Okta = 'okta',
}

export interface UserAttributes {
  id: number;
  lastRequestedAt: number | null;
  email: string;
  provider: AuthProvider;
  clientId: number;
  role: Role;
  uid: string;
  allowPasswordChange: boolean;
  enabled: boolean;
  deleted: boolean;
  otpRequiredForLogin: boolean | null;
  otpNeedEnable: boolean;
  deletedAt: number | null;
  clientName: string;
  shoppingPlatformEnabled: boolean;
  shoppingPlatformName: string | null;
  shoppingPlatformId: number | null;
  allowAddProduct: boolean;
  productImagesRequired: boolean;
  clientLanguages: string[];
  clientLanguagesFull: string[];
  isOktaUser: boolean;
  clientInternalHost: string;
  clientInternalSubdomain: string;
  planogramId: number | null;
  clientOwner: boolean;
  clientTemplates: boolean;
}

export interface UserState {
  currentUser: {
    isLoading: boolean;
    isSignedIn: boolean;
    attributes: UserAttributes;
  };
}

export interface SignInParams {
  clientName: string;
  email: string;
  password: string;
  otpAttempt?: string;
}

export interface PasswordUpdateParams {
  password: string;
  passwordConfirmation: string;
}

export interface PasswordInviteParams {
  clientName: string;
  email: string;
}

export interface VerifyPasswordResetParams {
  resetPasswordToken: string;
}

export interface SignUpParams {
  clientName: string;
  email: string;
  advertiseNotifications: boolean;
}

export interface SignUpParamsWithCaptcha extends SignUpParams {
  hCaptchaResponse: string;
}

export interface VerifyEmailTokenParams {
  token: string | boolean;
}

export interface SetPasswordParams {
  password: string;
  token: string;
}
export interface PasswordInviteWithCaptcha extends PasswordInviteParams {
  hCaptchaResponse: string;
}

export interface QRCodeAsSvg {
  qrCodeAsSvg: string;
}

export interface TFASettings {
  otpNeedEnable: boolean;
}

export interface TFASettingsPutParams {
  id: number;
  twoFa: TFASettings;
}

export interface TFASettingsPostParams {
  twoFa: {
    code: string;
  };
}

export interface ResetEmailParams {
  email: string;
  clientName: string;
}

export interface ResetTFAParams {
  token: string;
}

export interface OmniAuthTokenParams {
  token: string;
}

export interface SocialSignInParams {
  token: string;
  id: number;
}

export interface SocialSignUpParams {
  token: string;
  clientName: string;
}
export interface SocialSignUpResponse {
  pubtoolToken: string;
  message: string;
}

export interface SocialAccount {
  client: string;
  email: string;
  client_full_name: string;
  id: number;
}

export interface ListAccountsResponse {
  accounts: SocialAccount[];
  pubtoolToken: string | null;
}

export interface CloneRequestParams {
  userAccessToken: string;
}

export interface CloneRequestResponse {
  admin: UserAttributes;
  authToken: {
    pubtoolToken: string;
  };
  success: string[];
}
